import { render } from "./RulesView.vue?vue&type=template&id=6613e4b8"
import script from "./RulesView.vue?vue&type=script&lang=js"
export * from "./RulesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__